import { render, staticRenderFns } from "./MyStocks.vue?vue&type=template&id=65c650b2&scoped=true&"
import script from "./MyStocks.vue?vue&type=script&lang=js&"
export * from "./MyStocks.vue?vue&type=script&lang=js&"
import style0 from "./MyStocks.vue?vue&type=style&index=0&id=65c650b2&lang=less&scoped=true&"
import style1 from "./MyStocks.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c650b2",
  null
  
)

export default component.exports